
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[slug]/bookmarks",
      function () {
        return require("private-next-pages/author/[slug]/bookmarks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/[slug]/bookmarks"])
      });
    }
  